const CryptoJS = require('crypto-js')
const key = CryptoJS.enc.Hex.parse('7472696d616e3132333435363738393130305452494d414e3132333435363738') //密钥
const iv = CryptoJS.enc.Hex.parse('726b676c776c79313233343536373839') //密钥偏移量

/**
 * 加密
 * @param word
 * @returns {*}
 */
function encrypt(word) {
  // let key = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12')
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString()
}

/**
 * 解密
 * @param word
 * @returns {*}
 */
function decrypt(word) {
  // let key = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12')
  let decrypt = CryptoJS.AES.decrypt(word, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

export default {
  decrypt,
  encrypt
}
